import { render, staticRenderFns } from "./ItemizeTravel.vue?vue&type=template&id=6b053370"
import script from "./ItemizeTravel.vue?vue&type=script&lang=js"
export * from "./ItemizeTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports